import axiosPublicInstance from "module/common/utils/axiosConfig";
export var getMonthlyStats = function (url, refresh) {
    if (url === void 0) { url = "/api/account/get_monthly_stats?offset=0&limit=1"; }
    if (refresh === void 0) { refresh = false; }
    url = refresh ? "".concat(url, "&refresh=true") : url;
    return axiosPublicInstance.get(url);
};
export var getDailyStats = function (year, month) {
    return axiosPublicInstance.get("/api/account/get_daily_stats?year=".concat(year, "&month=").concat(month));
};
